import { InteractionPanel } from "@/components/organisms/interaction";
import { WorkspacePanel } from "@/components/organisms/workspace";
import { Position } from "@/common/theme/styleUtils";
import { useStyle } from "./style";
import { InteractionCard } from "@/components/organisms/interaction/InteractionCard";
import { CacheKey } from "@/common/stores/persistingStores/app";
import { ResizableContainer } from "@/components/atoms/resizableContainer";
import { ContainerSizeDefaults } from "@/common/constants";
import { useResizeHook } from "@/hooks/resize";
import { ResizeHint } from "@/components/atoms/resizeHint";
import { useMemo } from "react";
import { useResponsiveBreakpoints } from "@/hooks/responsive";
import {
	NavigationState,
	useNavigationStore,
} from "@/common/stores/persistingStores/navigation";

export const Agent = () => {
	const classes = useStyle();

	const [interactionPanelWidth, onResizeStop] = useResizeHook(
		CacheKey.InteractionPanelWidth,
		ContainerSizeDefaults.InteractionPanelWidth
	);

	const { isTablet, isMobile } = useResponsiveBreakpoints();

	const isMobileDetailViewMode = useNavigationStore(
		(state: NavigationState) => state.isMobileDetailViewMode
	);

	const maxWidth = useMemo(() => {
		if (isTablet) {
			return ContainerSizeDefaults.PanelsMaxWidthOnTablet;
		}

		return ContainerSizeDefaults.InteractionPanelMaxWidth;
	}, [isTablet]);

	const resizableContainerView = useMemo(
		() => (
			<ResizableContainer
				minWidth={ContainerSizeDefaults.InteractionPanelWidth}
				maxWidth={maxWidth}
				width={interactionPanelWidth}
				enabledSides={["right"]}
				handleStyles={{ right: { right: "0px", width: "1.5px" } }}
				handleComponent={{
					right: <ResizeHint className={classes.resizeHintRight} />,
				}}
				children={<InteractionPanel shadowTo={Position.Right} />}
				onResizeStop={onResizeStop}
			></ResizableContainer>
		),
		[maxWidth, interactionPanelWidth]
	);

	const desktopView = useMemo(
		() => (
			<>
				{resizableContainerView}
				<WorkspacePanel />
			</>
		),
		[isMobileDetailViewMode, maxWidth, interactionPanelWidth]
	);

	const mobileView = useMemo(() => {
		return isMobileDetailViewMode ? (
			<WorkspacePanel />
		) : (
			<InteractionPanel shadowTo={Position.Right} />
		);
	}, [isMobileDetailViewMode]);

	return (
		<div className={classes.container}>
			{isMobile ? mobileView : desktopView}
			{!isMobile && <InteractionCard />}
		</div>
	);
};
